import type { AxiosInstance } from "axios";

import { parseAxiosResponse } from "@thalamos/common";
import type { ActivityPage, PersonId } from "@thalamos/haven-common";
import { ActivityResponseSchema } from "@thalamos/haven-common";

import type { ErrorBody, ResponseBody } from "../axios/api.js";
import { useApiAxios } from "../axios/api.js";

const parseResponseActivity = parseAxiosResponse(ActivityResponseSchema);

/** A page of a young person's activity, as a caller asks for it. */
export type ActivityPaging = {
  limit?: number;
  offset?: number;
};

export const config = {
  personActivity: {
    forPerson: (personId: PersonId, paging: ActivityPaging = {}) => ({
      url: `/api/persons/${personId}/activity`,
      method: "get",
      params: {
        ...(paging.limit === undefined ? {} : { limit: paging.limit }),
        // Zero is the first page, so it has to survive a check a truthiness
        // test would drop.
        ...(paging.offset === undefined ? {} : { offset: paging.offset }),
      },
      transformResponse: parseResponseActivity,
    }),
  },
};

export const api = (apiAxios: AxiosInstance) => {
  return {
    personActivity: {
      forPerson: (personId: PersonId, paging: ActivityPaging = {}) =>
        apiAxios.request<ResponseBody<ActivityPage, ErrorBody>>(
          config.personActivity.forPerson(personId, paging),
        ),
    },
  };
};

export const apiHooks = () => {
  return {
    personActivity: {
      forPerson: function usePersonActivity(
        personId: PersonId,
        paging: ActivityPaging = {},
      ) {
        return useApiAxios<ActivityPage>(
          config.personActivity.forPerson(personId, paging),
        );
      },
    },
  };
};
